const FormLabel = ({ label }: { label: string }) => {
    return(
        <p className="text-[#212121] w-full text-sm font-normal pt-2">
            {label}
        </p>
    )
}

export default FormLabel
